import React, { Children, useLayoutEffect, useRef, useState } from 'react';

// Render only complete rows that fit; full lists remain available via panel links.
export const DashboardPreview = ({ children, className = '', testId }) => {
  const container = useRef(null);
  const [capacity, setCapacity] = useState(0);
  const items = Children.toArray(children);

  useLayoutEffect(() => {
    const element = container.current;
    const measure = () => {
      const style = getComputedStyle(element);
      const rowHeight = parseFloat(style.getPropertyValue('--preview-row-height'));
      const gap = parseFloat(style.rowGap) || 0;
      const columns = style.gridTemplateColumns.split(' ').length;
      const rows = Math.max(0, Math.floor((element.clientHeight + gap) / (rowHeight + gap)));
      setCapacity(rows * columns);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  return (
    <div ref={container} className={`dashboard-preview ${className}`} data-testid={testId}>
      {items.slice(0, capacity)}
    </div>
  );
};